import IMask from 'imask'

/**
 *
 * @param {HTMLInputElement} input
 * @param {object} options
 */
export function loadInputImask(input, options) {
  IMask(input, {
    ...options,
  })
}
